<template>
  <div class="product-success">
    <img src="../assets/success.png" alt="" />
    <div class="title c-muli-bold">{{ $t("THANK YOU FOR YOUR COMMENTS") }}</div>
    <div class="desc c-muli-light">
      {{ $t("We love seeing reviews") }}
    </div>
    <div class="btns">
      <c-button @click="onClickBack">{{ $t("VIEW COMMENTS") }}</c-button>
      <c-button type="primary" :url="$t('shopping')" target="_blank">{{
        $t("GO SHOPPING")
      }}</c-button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const i18n = useI18n();

console.log(i18n.locale.value);

const router = useRouter();

const onClickBack = () => {
  localStorage.setItem("skip-product-check", "1");
  router.back();
};
</script>

<style lang="less" scoped>
@media (max-width: 768px) {
  .product-success {
    text-align: center;
    padding-top: 40px;
    color: #333;

    img {
      width: 108px;
      height: 108px;
      margin-bottom: 12px;
    }

    .title {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 12px;
      text-transform: uppercase;
    }

    .desc {
      font-size: 14px;
      line-height: 21px;
      margin-bottom: 24px;
      padding: 0 25px;
    }

    .btns {
      padding: 0 16px;
      display: flex;
      margin-bottom: 40px;
      flex-direction: column-reverse;

      button {
        display: block;
        text-transform: uppercase;
        width: 100%;
        height: 44px;

        &:not(:first-child) {
          margin-bottom: 12px;
        }
      }
    }
  }
}

@media (min-width: 769px) {
  .product-success {
    text-align: center;
    padding-top: 40px;
    padding-bottom: 160px;
    color: #333;

    img {
      width: 120px;
      height: 120px;
      margin-bottom: 12px;
    }

    .title {
      font-size: 18px;
      line-height: 23px;
      margin-bottom: 12px;
      text-transform: uppercase;
    }

    .desc {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 40px;
    }

    .btns {
      button {
        text-transform: uppercase;
        min-width: 216px;
        margin: 0 6px;
      }
    }
  }
}
</style>
